import { AutoPopulate } from './component.styles'

export default AutoPopulate
